import { useTranslation } from "next-i18next";
import { socialNetworks, utilityLinks, workWithUsLinkProps } from "../../data/contact-info";
import { StaticI18nLink } from "../Link";
import {
	FooterContainer,
	FooterContent,
	LogoWrapper,
	LinksSection,
	FooterLink,
	AddressSection,
	AddressTitle,
	AddressLines,
	AddressLine,
	NewsletterSection,
	NewsletterContent,
	NewsletterTitle,
	NewsletterInputWrapper,
	NewsletterInput,
	NewsletterButton,
	SocialLinks,
	SocialIcon,
	CopyrightBar,
} from "./styles";

function ChevronRightIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
		>
			<path
				d="M9 5L16 12L9 19"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function InstagramIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
		>
			<g clipPath="url(#clip0_ig)">
				<path
					d="M13.234 0.00147642C14.1096 -0.00188373 14.9853 0.00691691 15.8606 0.0278756L16.0934 0.0362753C16.3622 0.045875 16.6274 0.0578745 16.9478 0.072274C18.2245 0.132272 19.0957 0.333865 19.86 0.630255C20.652 0.935045 21.3192 1.34783 21.9863 2.01501C22.5963 2.61452 23.0685 3.3397 23.3699 4.14014C23.6662 4.90451 23.8678 5.77688 23.9278 7.05364C23.9422 7.37283 23.9542 7.63922 23.9638 7.90801L23.971 8.1408C23.9923 9.0158 24.0016 9.89106 23.9986 10.7663L23.9998 11.6615V13.2334C24.0028 14.1091 23.9936 14.9847 23.9722 15.8601L23.965 16.0929C23.9554 16.3617 23.9434 16.6269 23.929 16.9473C23.869 18.2241 23.665 19.0952 23.3699 19.8596C23.0695 20.6609 22.5972 21.3867 21.9863 21.9859C21.3863 22.5959 20.6608 23.068 19.86 23.3695C19.0957 23.6659 18.2245 23.8675 16.9478 23.9275C16.6274 23.9419 16.3622 23.9539 16.0934 23.9635L15.8606 23.9707C14.9853 23.992 14.1096 24.0012 13.234 23.9983L12.3388 23.9995H10.7681C9.89246 24.0024 9.01683 23.9932 8.14144 23.9719L7.90865 23.9647C7.6238 23.9543 7.33901 23.9423 7.0543 23.9287C5.77756 23.8687 4.90641 23.6647 4.14085 23.3695C3.34011 23.0687 2.61481 22.5965 2.01575 21.9859C1.40504 21.3863 0.93248 20.6606 0.631026 19.8596C0.334642 19.0952 0.133052 18.2241 0.0730548 16.9473C0.059691 16.6626 0.0476915 16.3778 0.0370567 16.0929L0.0310572 15.8601C0.00893459 14.9847 -0.00106597 14.1091 0.00105858 13.2334V10.7663C-0.00229041 9.89106 0.00651007 9.01581 0.0274573 8.1408L0.0358568 7.90801C0.0454563 7.63922 0.0574557 7.37283 0.071855 7.05364C0.131852 5.77568 0.333441 4.90571 0.629826 4.14014C0.931458 3.33931 1.40494 2.61432 2.01696 2.01621C2.6156 1.40513 3.34044 0.932132 4.14085 0.630255C4.90641 0.333865 5.77636 0.132272 7.0543 0.072274L7.90865 0.0362753L8.14144 0.0302756C9.01642 0.00816377 9.89165 -0.00183696 10.7669 0.000276552L13.234 0.00147642ZM12.0004 6.00127C11.2055 5.99003 10.4162 6.1369 9.67853 6.43334C8.94084 6.72978 8.26941 7.16989 7.70328 7.72808C7.13714 8.28627 6.6876 8.95142 6.38076 9.68486C6.07392 10.4183 5.9159 11.2054 5.9159 12.0005C5.9159 12.7955 6.07392 13.5826 6.38076 14.3161C6.6876 15.0495 7.13714 15.7147 7.70328 16.2729C8.26941 16.831 8.94084 17.2712 9.67853 17.5676C10.4162 17.864 11.2055 18.0109 12.0004 17.9997C13.5917 17.9997 15.1177 17.3675 16.2429 16.2424C17.368 15.1172 18.0001 13.5911 18.0001 11.9999C18.0001 10.4086 17.368 8.88255 16.2429 7.75737C15.1177 6.63219 13.5917 6.00127 12.0004 6.00127ZM12.0004 8.40119C12.4786 8.39238 12.9538 8.47894 13.3981 8.65583C13.8425 8.83272 14.2471 9.09638 14.5884 9.43141C14.9298 9.76644 15.2009 10.1661 15.386 10.6071C15.5711 11.0481 15.6665 11.5216 15.6666 11.9999C15.6667 12.4781 15.5714 12.9516 15.3865 13.3927C15.2015 13.8337 14.9305 14.2335 14.5893 14.5687C14.2481 14.9038 13.8435 15.1676 13.3992 15.3446C12.9549 15.5217 12.4798 15.6084 12.0016 15.5997C11.0469 15.5997 10.1313 15.2205 9.45619 14.5454C8.78109 13.8703 8.40183 12.9546 8.40183 11.9999C8.40183 11.0451 8.78109 10.1295 9.45619 9.45437C10.1313 8.77926 11.0469 8.39999 12.0016 8.39999L12.0004 8.40119ZM18.3001 4.20133C17.913 4.21683 17.5469 4.38151 17.2785 4.66088C17.0101 4.94026 16.8602 5.31266 16.8602 5.70008C16.8602 6.08751 17.0101 6.45991 17.2785 6.73928C17.5469 7.01866 17.913 7.18334 18.3001 7.19883C18.6979 7.19883 19.0794 7.0408 19.3607 6.75951C19.642 6.47821 19.8 6.09669 19.8 5.69888C19.8 5.30107 19.642 4.91955 19.3607 4.63826C19.0794 4.35696 18.6979 4.19893 18.3001 4.19893V4.20133Z"
					fill="white"
				/>
			</g>
			<defs>
				<clipPath id="clip0_ig">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

function LinkedInIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
		>
			<g clipPath="url(#clip0_li)">
				<path
					d="M21.3337 0C22.0409 0 22.7192 0.280956 23.2193 0.781061C23.7194 1.28117 24.0004 1.95945 24.0004 2.66671V21.3337C24.0004 22.0409 23.7194 22.7192 23.2193 23.2193C22.7192 23.7194 22.0409 24.0004 21.3337 24.0004H2.66671C1.95945 24.0004 1.28117 23.7194 0.78106 23.2193C0.280956 22.7192 0 22.0409 0 21.3337V2.66671C0 1.95945 0.280956 1.28117 0.78106 0.781061C1.28117 0.280956 1.95945 0 2.66671 0H21.3337ZM20.667 20.667V13.6002C20.667 12.4474 20.209 11.3418 19.3939 10.5266C18.5787 9.71143 17.4731 9.25348 16.3202 9.25348C15.1869 9.25348 13.8669 9.94682 13.2269 10.9868V9.50681H9.50681V20.667H13.2269V14.0935C13.2269 13.0669 14.0535 12.2269 15.0802 12.2269C15.5753 12.2269 16.0501 12.4235 16.4002 12.7736C16.7503 13.1237 16.9469 13.5985 16.9469 14.0935V20.667H20.667ZM5.17341 7.41345C5.76751 7.41345 6.33727 7.17744 6.75736 6.75736C7.17744 6.33727 7.41345 5.76751 7.41345 5.17341C7.41345 3.93339 6.41343 2.92005 5.17341 2.92005C4.57578 2.92005 4.00263 3.15745 3.58004 3.58004C3.15745 4.00263 2.92004 4.57578 2.92004 5.17341C2.92004 6.41343 3.93339 7.41345 5.17341 7.41345ZM7.02677 20.667V9.50681H3.33338V20.667H7.02677Z"
					fill="white"
				/>
			</g>
			<defs>
				<clipPath id="clip0_li">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

export function Footer2026() {
	const { t } = useTranslation();

	return (
		<>
			<FooterContainer>
				<FooterContent>
					<LogoWrapper>
						<img
							src="/landings/assets/images/LogoVerzelHorizontal.svg"
							alt="Verzel"
							className="mobile-logo"
						/>
						<img
							src="/landings/assets/images/logo-verzel-vertical-white.svg"
							alt="Verzel"
							className="desktop-logo"
						/>
					</LogoWrapper>

					<LinksSection>
						<StaticI18nLink href="/#about" passHref>
							<FooterLink>QUEM SOMOS</FooterLink>
						</StaticI18nLink>
						<StaticI18nLink href="/cases/1" passHref>
							<FooterLink>CASES DE CLIENTES</FooterLink>
						</StaticI18nLink>
						<StaticI18nLink href="/blog" passHref>
							<FooterLink>ÚLTIMAS NOTÍCIAS</FooterLink>
						</StaticI18nLink>
						<FooterLink
							href={utilityLinks.workWithUs}
							{...workWithUsLinkProps}
						>
							FAÇA PARTE DO NOSSO TIME
						</FooterLink>
					</LinksSection>

					<AddressSection>
						<AddressTitle>ENDEREÇO</AddressTitle>
						<AddressLines>
							<AddressLine>Rua Aníbal Benévolo, 94 - 2° Andar</AddressLine>
							<AddressLine>Santana - São Paulo/SP</AddressLine>
							<AddressLine>CEP 02016-040</AddressLine>
						</AddressLines>
					</AddressSection>

					<NewsletterSection>
						<NewsletterContent>
							<NewsletterTitle>
								Fique por dentro dos nossos conteúdos!
							</NewsletterTitle>
							<NewsletterInputWrapper>
								<NewsletterInput type="email" placeholder="E-mail" />
								<NewsletterButton type="button" aria-label="Enviar">
									<ChevronRightIcon />
								</NewsletterButton>
							</NewsletterInputWrapper>
						</NewsletterContent>
						<SocialLinks>
							<SocialIcon
								href={socialNetworks.instagram}
								target="_blank"
								rel="noopener noreferrer"
								aria-label="Instagram"
							>
								<InstagramIcon />
							</SocialIcon>
							<SocialIcon
								href={socialNetworks.linkedin}
								target="_blank"
								rel="noopener noreferrer"
								aria-label="LinkedIn"
							>
								<LinkedInIcon />
							</SocialIcon>
						</SocialLinks>
					</NewsletterSection>
				</FooterContent>
			</FooterContainer>

			<CopyrightBar>
				Copyright © {new Date().getFullYear()} Verzel. {t("footer.copyright")}
			</CopyrightBar>
		</>
	);
}
